import React, {
  forwardRef,
  use,
  useContext,
  useEffect,
  useLayoutEffect,
} from "react";
import classNames from "classnames";
// import { useNavigate } from "react-router-dom";
import AuthContext from "../../Contexts/authContext";
import { REACT_APP_META_DESC } from "../../Utils/Constant";

const PageWrapper = forwardRef(
  (
    {
      isProtected = true,
      headerTitle,
      title,
      description,
      className,
      children,
    },
    ref
  ) => {
    useLayoutEffect(() => {
      // Set page title
      document.getElementsByTagName("TITLE")[0].text = `${
        title ? `${title} - APT | ` : ""
      }${process.env.REACT_APP_SITE_NAME}`;
      // Set meta description
      document
        ?.querySelector('meta[name="description"]')
        .setAttribute("content", description || REACT_APP_META_DESC || "");
    });

    //Set header Title
    useEffect(() => {
      const headerEl = document.querySelector("header-title");
      if (headerEl) {
        headerEl.textContent = headerTitle ? `${headerTitle}` : "";
      }
    }, [headerTitle]);

    // Set menu Title
    useEffect(() => {
      const titleEl = document.querySelector("menu-title");
      if (titleEl) {
        titleEl.textContent = title ? `${title}` : `${headerTitle}`;
      }
    }, [title, headerTitle]);

    const { isAuthenticated } = useContext(AuthContext);
    // const navigate = useNavigate();

    // useEffect(() => {
    //   if (isProtected && !isAuthenticated) {
    //     console.log(isAuthenticated, "====1==== User not authenticated");
    //     // navigate("./login");
    //     // handleSessionExpired(); // 👈 show popup and redirect
    //   }
    //   return () => {};
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    return (
      <div
        ref={ref}
        className={classNames("page-wrapper", "container-fluid", className)}
      >
        {children}
      </div>
    );
  }
);

export default PageWrapper;
